import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import Header from 'pages/ipu/Header';
import Body from 'pages/ipu/Body';
import SubHeader from 'pages/ipu/SubHeader';
import { iPromoteuPdf2json } from 'actions/orders';
import Alert from '@material-ui/lab/Alert';
import SubmittedOrdersModal from 'pages/ipu/SubmittedOrdersModal';
import SaveToProductModal from 'pages/ipu/SaveToProductModal';
import { populateOrderData } from 'pages/ipu/helper';
import { Container } from 'styles/pages/staples-bulk-orders';

const StaplesBulkOrders = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    printProvider: 'CA',
    poSubmittedModalVisibility: false,
  });

  const getData = async () => {
    let data = await dispatch(
      iPromoteuPdf2json({
        pdfUrl: state?.poPdfPath,
        // publicId: state?.poPdfPublicId,
        // orderType: state?.isStaplesOrder ? 'staples' : 'non-staples',
        // staplesShipDate: state?.staplesShipDate,
      })
    );

    const order = populateOrderData(data);

    const r = {
      orderPdfData: order?.data,
      additionalInfoWithLineItems: order?.additionalInfoWithLineItems,
      poPdfPath: order?.data?.pdfUrl,
      status: order?.data?.status,
      staplesShipDate: data?.staplesShipDate,
      stockReceivedDate: data?.stockReceivedDate,
      botShipDate: data?.botShipDate,
    };

    if (data?.success === false) {
      setState({
        ...state,
        poSubmittedModalVisibility: true,
        poSubmittedModalMessage: order?.data?.message,
        poSubmitted: false,
        saveToProductionModal: false,
        aiNumber: data?.aiNumber,
        ...r,
      });
      return;
    }

    setState({
      ...state,
      poSubmittedModalVisibility: true,
      poSubmittedModalMessage: order?.data?.message,
      poSubmitted: true,
      saveToProductionModal: false,
      aiNumber: data?.aiNumber,

      ...r,
    });
  };

  useEffect(() => {
    if (state.poPdfPath) getData();
  }, [state.poPdfPath]);

  return (
    <Container>
      <Header state={state} setState={setState} />
      {!!state?.orderPdfData?.orderPO?.length && (
        <SubHeader state={state} setState={setState} />
      )}
      {!!state?.orderPdfData && <Body state={state} setState={setState} />}

      <Snackbar
        key="snack-bar"
        autoHideDuration={3000}
        onClose={() =>
          setState({
            ...state,
            poSubmittedModalVisibility: false,
          })
        }
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={state?.poSubmittedModalVisibility}
      >
        <Alert severity={state?.poSubmitted ? 'success' : 'warning'}>
          {state?.poSubmittedModalMessage}
        </Alert>
      </Snackbar>

      {state?.submittedOrdersModal && (
        <SubmittedOrdersModal
          state={state}
          setState={setState}
          open={state?.submittedOrdersModal}
          setOpen={() =>
            setState({
              ...state,
              submittedOrdersModal: false,
            })
          }
        />
      )}

      {state?.saveToProductionModal && (
        <SaveToProductModal
          state={state}
          setState={setState}
          reload={() => getData()}
        />
      )}
    </Container>
  );
};

export default StaplesBulkOrders;
